import moment from 'moment'
import { MENU } from '../../helpers'

export const setLocalStorage = (name, data) => {
  return localStorage.setItem(name, JSON.stringify(data))
}

export const getLocalStorage = name => {
  try {
    return JSON.parse(localStorage.getItem(name))
  } catch (_) {
    return undefined
  }
}

export const removeLocalStorage = name => {
  localStorage.removeItem(name)
}

export const setSessionStorage = (name, data) => {
  return sessionStorage.setItem(name, JSON.stringify(data))
}

export const getSessionStorage = name => {
  try {
    return JSON.parse(sessionStorage.getItem(name))
  } catch (_) {
    return undefined
  }
}

export const removeSessionStorage = name => {
  sessionStorage.removeItem(name)
}

export const cutString2 = (text, index) => {
  // text = text? text: 'mock'
  return text? text.length > index ? text.slice(0, index) + '...' : text: '-'
}

export const routePath = () => {
  const route = []
  for (const i in MENU) {
    route.push(MENU[i])
  }
  return route
}

export function getNearestMinute (value, minuteStep, mode = 2) {
  const leftOver = value % minuteStep
  switch (mode) {
    case 1:
      if (minuteStep - leftOver < Math.floor(minuteStep / 2)) {
        value = value + minuteStep - leftOver
      } else {
        value = value - leftOver
      }
      return value
    default:
      if (leftOver === 0) return value
      return value + minuteStep - leftOver
  }
}

export function getDateTimeFrommySqlString (data) {
  const dateTime = moment(data).format().split('T')
  let time = dateTime[1].split('.', 1)
  const date = dateTime[0].split('-')
  time = time[0].split(':')
  return new Date(date[0], date[1] - 1, date[2], ...time)
}

export function getDisabledHour (disabledMinute, minuteStep, startSelectable, selectedDate) {
  const result = []
  const stepInHour = Math.round(60 / minuteStep)
  if (startSelectable &&
    selectedDate &&
    startSelectable.toDateString() !== selectedDate.toDateString()) startSelectable = null
  const startSelectMinute = startSelectable ? startSelectable.getMinutes() : -1
  const startSelectHour = startSelectable ? startSelectable.getHours() : -1
  if (disabledMinute[startSelectHour] != null &&
    new Set(disabledMinute[startSelectHour]).size + Math.round(getNearestMinute(startSelectMinute, minuteStep) / minuteStep) >= stepInHour) {
    result.push(parseInt(startSelectHour))
  }
  Object.entries(disabledMinute).forEach((keyValue) => {
    if (keyValue[0] !== startSelectHour &&
      new Set(keyValue[1]).size >= stepInHour) {
      result.push(parseInt(keyValue[0]))
    }
  })
  return result
}

export function convertBooklistToDisabledMinute (data, minuteStep, bookingId = null) {
  const result = {}
  const minute = 60 * 1000
  const stepInHour = Math.round(60 / minuteStep) + 1
  data.forEach((booking) => {
    if (bookingId == null || bookingId !== booking.id) {
      const startDatetime = getDateTimeFrommySqlString(booking.startDatetime)
      const endDatetime = getDateTimeFrommySqlString(booking.endDatetime)
      const totalMinute = (endDatetime - startDatetime) / minute
      const totalStep = Math.round(totalMinute / minuteStep)
      const startStep = Math.floor(startDatetime.getMinutes() / minuteStep)
      let currentHour = startDatetime.getHours()
      let offset = 0
      for (let i = 0; i < totalStep; i++) {
        let currentMinute = ((i + startStep + offset) % stepInHour) * minuteStep
        if (currentMinute >= 60) {
          currentHour = currentHour + 1
          currentMinute = 0
          offset = offset + 1
        }
        if (result[currentHour] != null) {
          result[currentHour].push(currentMinute)
        } else {
          result[currentHour] = [currentMinute]
        }
      }
    }
  })
  return Object.assign({}, result)
}

export function range (start, end, step = 1) {
  const result = []
  for (let i = start; i < end; i += step) {
    result.push(i)
  }
  return result
}

export function getLocaleDateString (dt, language = 'EN') {
  switch (language.toUpperCase()) {
    case 'TH':
      return dt.toLocaleDateString(
        'th-TH-u-ca-gregory',
        {
          weekday: 'short',
          month: 'short',
          year: 'numeric',
          day: 'numeric'
        }
      )
    default:
      return dt.toLocaleDateString(
        'en-EN-u-ca-gregory',
        {
          weekday: 'short',
          month: 'short',
          year: 'numeric',
          day: 'numeric'
        }
      )
  }
}

export function getLocaleDateStringFull (dt, language = 'EN') {
  switch (language.toUpperCase()) {
    case 'TH':
      return dt.toLocaleDateString(
        'th-TH-u-ca-gregory',
        {
          month: 'long',
          year: 'numeric',
          day: 'numeric'
        }
      )
    default:
      return dt.toLocaleDateString(
        'en-GB-u-ca-gregory',
        {
          month: 'long',
          year: 'numeric',
          day: 'numeric'
        }
      )
  }
}

export function getLocaleDateStringWithoutYear (dt, language = 'EN') {
  switch (language.toUpperCase()) {
    case 'TH':
      return dt.toLocaleDateString(
        'th-TH-u-ca-gregory',
        {
          weekday: 'long',
          month: 'long',
          day: 'numeric'
        }
      )
    default:
      return dt.toLocaleDateString(
        'en-EN-u-ca-gregory',
        {
          weekday: 'long',
          month: 'long',
          day: 'numeric'
        }
      )
  }
}

export function getWeekDayName (dt, language = 'EN') {
  switch (language.toUpperCase()) {
    case 'TH':
      return dt.toLocaleDateString(
        'th-TH-u-ca-gregory',
        {
          weekday: 'short'
        }
      )
    default:
      return dt.toLocaleDateString(
        'en-GB-u-ca-gregory',
        {
          weekday: 'short'
        }
      )
  }
}

export function getWeekDayNameFull (dt, language = 'EN') {
  switch (language.toUpperCase()) {
    case 'TH':
      return dt.toLocaleDateString(
        'th-TH-u-ca-gregory',
        {
          weekday: 'long'
        }
      )
    default:
      return dt.toLocaleDateString(
        'en-GB-u-ca-gregory',
        {
          weekday: 'long'
        }
      )
  }
}

export function getMonthName (dt, language = 'EN') {
  switch (language.toUpperCase()) {
    case 'TH':
      return dt.toLocaleDateString(
        'th-TH-u-ca-gregory',
        {
          month: 'short'
        }
      )
    default:
      return dt.toLocaleDateString(
        'en-GB-u-ca-gregory',
        {
          month: 'short'
        }
      )
  }
}

export function getMonthNameFull (dt, language = 'EN') {
  switch (language.toUpperCase()) {
    case 'TH':
      return dt.toLocaleDateString(
        'th-TH-u-ca-gregory',
        {
          month: 'long'
        }
      )
    default:
      return dt.toLocaleDateString(
        'en-GB-u-ca-gregory',
        {
          month: 'long'
        }
      )
  }
}

export function getLocaleDateTimeString (dt, language) {
  switch (language) {
    case 'TH':
      return dt.toLocaleString(
        'th-TH-u-ca-gregory',
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        }
      )
    default:
      return dt.toLocaleString(
        'en-EN-u-ca-gregory',
        {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hourCycle: 'h12',
          hour: '2-digit',
          minute: '2-digit'
        }
      )
  }
}

export function getLocaleTimeString (dt, language) {
  switch (language) {
    case 'TH':
      return dt.toLocaleTimeString(
        'th-TH-u-ca-gregory',
        {
          hour: '2-digit',
          minute: '2-digit'
        }
      )
    default:
      return dt.toLocaleTimeString(
        'en-EN-u-ca-gregory',
        {
          hourCycle: 'h23',
          hour: '2-digit',
          minute: '2-digit'
        }
      )
  }
}

export function getMonthString (dt, language) {
  switch (language) {
    case 'TH':
      return dt.toLocaleDateString(
        'th-TH-u-ca-gregory',
        {
          month: 'long'
        }
      )
    default:
      return dt.toLocaleDateString(
        'en-EN-u-ca-gregory',
        {
          month: 'long'
        }
      )
  }
}

export function getCalendarString (dt, language) {
  let result = ''
  switch (language) {
    case 'TH':
      result = dt.toLocaleDateString('th-TH-u-ca-gregory', { weekday: 'long', month: 'long', day: 'numeric' })
      break
    default:
      let dateSuffix = 'th'
      if ([1, 21, 31].includes(dt.getDate())) {
        dateSuffix = 'st'
      } else if ([2, 22].includes(dt.getDate())) {
        dateSuffix = 'nd'
      } else if ([3, 23].includes(dt.getDate())) {
        dateSuffix = 'rd'
      }
      result = dt.toLocaleDateString('en-EN-u-ca-gregory', { weekday: 'long', month: 'long', day: 'numeric' })
      result = `${result}${dateSuffix}`
      break
  }
  return result
}

export function countOrderItems (orders, mode) {
  let total = 0
  switch (mode) {
    case 1:
      for (const order of orders) {
        for (const item of order.items) {
          if (item.type === 0 || item.type === 1) total = total + (item.amount ? item.amount : 0)
        }
      }
      break
    case 2:
      for (const order of orders) {
        for (const item of order.items) {
          if (item.type === 2) total = total + (item.amount ? item.amount : 0)
        }
      }
      break
    default:
      for (const order of orders) {
        for (const item of order.items) {
          total = total + (item.amount ? item.amount : 0)
        }
      }
  }
  return total
}

export function countNewItems (itemList, mode) {
  let total = 0
  let items = []
  switch (mode) {
    case 1:
      items = itemList[0].concat(itemList[1])
      break
    case 2:
      items = itemList[2]
      break
    default:
      items = itemList
        ? Object.values(itemList).reduce((total, item) => total.concat(item), [])
        : null;
      break
  }
  if (items){
    for (const item of items) {
      total = total + (item.amount ? item.amount : 0)
    }
  }
  return total
}

export function catagorizeItem (itemList) {
  const list = {
    0: [],
    1: [],
    2: []
  }
  for (const item of itemList) {
    switch (item.type) {
      case 0:
        list[0].push({
          ...item,
          amount: 0
        })
        break
      case 1:
        list[1].push({
          ...item,
          amount: 0
        })
        break
      case 2:
        list[2].push({
          ...item,
          amount: 0
        })
        break
      default:
        break
    }
  }
  return list
}

export function catagorizeItem2 (itemList) {
  const list = {
    0: [],
    1: [],
    2: []
  }
  for (const item of itemList) {
    switch (item.type) {
      case 0:
        list[0].push(item)
        break
      case 1:
        list[1].push(item)
        break
      case 2:
        list[2].push(item)
        break
      default:
        break
    }
  }
  return list
}

export function catagorizeOrder (orderList) {
  const list = {
    1: [],
    2: []
  }
  orderList.forEach((order) => {
    const items = catagorizeItem2(order.items)
    let item = items[0].concat(items[1])
    if (item.length > 0) {
      list[1].push({
        ...order,
        items: items[0].concat(items[1])
      })
    }
    item = items[2]
    if (item.length > 0) {
      list[2].push({
        ...order,
        items: items[2]
      })
    }
  })
  return list
}

export function gatherAllItem (items) {
  const result = []

  for (const item of items) {
    if (item) {
      for (const obj of Object.entries(item)) {
        for (const v of obj[1]) {
          result.push(v)
        }
      }
    }
  }
  return result
}

export function gatherAllOrder (order1, order2) {
  const result = []
  for (const ord1 of order1) {
    for (const ord2 of order2) {
      if (ord1.orderId === ord2.orderId) {
        ord1.items = ord1.items.concat(ord2.items)
        break
      }
    }
    result.push(ord1)
  }
  return result
}

export const checkPermission = (listPermission, code) => {
  if (!listPermission) {
    return false
  } else {
    return listPermission.includes(code)
  }
}

export const jsonToArray = (json) => {
  const array = []
  for (const i in json) {
    array.push(json[i])
  }
  return array
}

export const getRoomBookingStatus = (status) => {
  return {
    isWaiting: () => status === 2,
    isInUse: () => status === 1,
    isComplete: () => status === 0,
  }
}
